import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";
import { IResourceChatDefinition } from "@app/shared/general/resource-chat/interfaces/resource-chat-definition.interfaces";

/** The damage fields its chat label reads; a damage may have lost its vehicle. */
interface IDamageChatLabel {
  id: string;
  entityId: string;
  vehicle?: { mainInfo?: { plateNumber?: string | null } | null } | null;
}

/**
 * Resource chat of damages.
 *
 * Registered in `app.config.ts`; the damage dialog routes and side panel refer to it
 * by name. Links always open the damage list's dialog, wherever else the dialog is mounted.
 */
export const DAMAGE_CHAT: IResourceChatDefinition<IDamageChatLabel> = {
  resourceName: "damage",
  typeLabel: "CHAT.RESOURCE_TYPES.DAMAGE",
  readPermission: PERMISSION_CONSTANTS.DAMAGE.CHAT_READ,
  recordQuery: "getDamage",
  accessQuery: "getDamageAccess",
  route: id => ["/fleet/damage/view", id],
  labelFields: "entityId vehicle { mainInfo { plateNumber } }",
  label: damage => [damage.entityId, damage.vehicle?.mainInfo?.plateNumber].filter(Boolean).join(" · "),
};
